import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

/*
  Supercluster expects items to be GeoJSON shape 
  https://tools.ietf.org/html/rfc7946#section-3.2
*/
export default handleActions(
  {
    [Actions.LOAD_DONE]: (_, { payload: { pins } }) =>
      pins
        ? pins.map(pin => ({
            id: pin.internalID,
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [pin._geoloc.lng, pin._geoloc.lat], // eslint-disable-line no-underscore-dangle
            },
          }))
        : [],
  },
  initialState,
);
